export enum TemporaryReplacementStatusEnum {
    PENDING = 'PENDING',
    COOK_ALLOCATED = 'COOK_ALLOCATED',
    ONGOING = 'ONGOING',
    FULFILLED = 'FULFILLED',
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED'
}